import { Col, Divider, Label, Row } from '@gower/react-ui/components';
import { DataGrid, DataGridColumn } from '@gower/react-ui/template/data-grid';
import { DetailField, DetailFieldVertical } from '@gower/react-ui/template/detail-field';
import React from 'react';
import { useStore } from '../../store';

export const DetailsTab: React.FC = () => {

    const store = useStore();
    const data = store.Authorization;

    return <>
        <Row>

            <Row padding={10}>
                <Col cols={6}>
                    <DetailField titleWidth={70} title="Convenio" value={data.Agreement.Description} />
                </Col>
                <Col cols={6}>
                    <DetailField titleWidth={70} title="Fecha" value={data.AuthorizationDate.format( 'DD/MM/YYYY HH:mm' )} />
                </Col>

                <Col cols={6}>
                    <DetailField titleWidth={70} title="Usuario" value={data.CreatedUser} />
                </Col>
                <Col cols={6}>
                    <DetailField titleWidth={70} title="Estado" value={data.Status.Description} />
                </Col>
            </Row>

            <Divider />

            <Row padding={10}>
                <Col cols={12}>
                    <DetailField title="Afiliado" noData={!Boolean( data.Affiliate?.Id )}>
                        <Label xxsmall bold label={data.Affiliate?.Id} />
                        <Label gutter xxsmall label={data.Affiliate?.Name} />
                    </DetailField>
                </Col>
            </Row>
            <Divider />
            <Row padding={10}>
                <Col cols={12}>
                    <DetailField title="Efector" noData={!Boolean( data.EffectorProfessional?.Id )}>
                        <Label xxsmall bold label={`MAT. ${ data.EffectorProfessional?.Id }`} />
                        <Label gutter xxsmall label={data.EffectorProfessional?.Name} />
                    </DetailField>
                </Col>
                <Col cols={12}>
                    <DetailField title="Solicitante" noData={!Boolean( data.ApplicantProfessional?.Id )}>
                        <Label xxsmall bold label={`MAT. ${ data.ApplicantProfessional?.Id }`} />
                        <Label gutter xxsmall label={data.ApplicantProfessional?.Name} />
                    </DetailField>
                </Col>
                <Col cols={12}>
                    <DetailField title="Facturación" noData={!Boolean( data.BillingProfessional?.Id )}>
                        <Label xxsmall bold label={`MAT. ${ data.BillingProfessional?.Id }`} />
                        <Label gutter xxsmall label={data.BillingProfessional?.Name} />
                    </DetailField>
                </Col>
            </Row>

            <Divider />

            <Row padding={10}>
                <Col cols={12}>
                    <DetailFieldVertical title="Observación" value={data.Message} noData={!data.Message} />
                </Col>
            </Row>

            <Divider />
            <Row padding={10}>
                <Col cols={12}>
                    <DetailField title="Prestaciones" noData={!Boolean( data.ServiceCodes?.length )}>
                        <Label xxsmall label={`${ String( data.ServiceCodes?.length ) } autorizada(s)`} />
                    </DetailField>
                </Col>
                <Col cols={12}>
                    <DetailField title="Importe copago">
                        <Label xxsmall label={data.CopaymentTotalAmount?.toCurrency()} />
                    </DetailField>
                </Col>
            </Row>

            <Divider />

            <Row columns paddingY={10}>
                <Col padding={15}>
                    <Label xxsmall bold label="Prestaciones" />
                </Col>
                <Col>
                    <DataGrid
                        data={data.ServiceCodes}
                        scroll
                        height={200}
                    >
                        <DataGridColumn title="Código" field="ServiceCode.Id" />
                        <DataGridColumn title="Desc." field="ServiceCode.Name" />
                        <DataGridColumn type="NUMBER" title="Cantidad" field="Quantity" />
                        <DataGridColumn type="CURRENCY" title="Copago" field="TotalAmount" />
                    </DataGrid>
                </Col>
            </Row>

        </Row>
    </>;

};
